import { useAuthContext } from "@/hooks/useAuthContext";
import { useFirestore } from "@/hooks/useFirestore";
import { useUserContext } from "@/hooks/useUserContext";
import React from "react";

export default function Step1() {
  const { user } = useAuthContext();
  const { userDoc } = useUserContext();
  const { updateDocument: updateUser } = useFirestore("users");
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          1
        </div>
        <h1 className="">
          Primeiro, clique no link abaixo para ser redirecionado para a página
          de cadastro da corretora.
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <div
          role="button"
          className="text-icon underline"
          onClick={async () => {
            const meaningfulActions = userDoc.meaningfulActions || {};
            await updateUser(user.uid, {
              meaningfulActions: {
                ...meaningfulActions,
                clickedAffiliateLink: {
                  status: true,
                  status_date: new Date().getTime(),
                },
              },
            });
            window.open("https://affs.click/qKlXb", "_blank");
          }}
        >
          Clique aqui
        </div>
      </div>
    </div>
  );
}
